import React, {FC, createContext, ReactNode, ReactElement} from 'react';
import RootStore, {IRootStore} from '../../stores/RootStore';

export const StoreContext = createContext<IRootStore>({} as IRootStore);
const store = new RootStore();

export type StoreComponent = FC<{
    children: ReactNode;
}>;

export const StoreProvider: StoreComponent = ({children}): ReactElement => (
    <StoreContext.Provider value={store}>{children}</StoreContext.Provider>
);
